import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';

import { RocketLaunch } from 'components/organisms/jobsDataTable/components/rocketLaunch';

export const SourcingBanner = ({ setIsVisible }) => (
  <Box
    sx={{
      position: 'relative',
      borderRadius: '4px',
      background:
        'linear-gradient(78deg, rgba(73, 0, 255, 0.03) -32.23%, rgba(212, 0, 255, 0.03) 40.71%, rgba(255, 146, 87, 0.03) 125.48%), #FFF',
      mb: 3,
      mx: '16px',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: '4px',
        padding: '1px',
        background: 'linear-gradient(78deg, #4900FF -32.23%, #D400FF 40.71%, #FF9257 125.48%), #FFF',
        mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        maskComposite: 'exclude',
        overflow: 'hidden',
      },
    }}
  >
    <Flex
      sx={{
        gap: '8px',
        alignItems: ['flex-start', 'center'],
        p: '8px',
        flexDirection: ['column', 'row'],
      }}
    >
      <Box
        as="button"
        type="button"
        onClick={() => setIsVisible(false)}
        aria-label="Close banner"
        title="Close banner"
        sx={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          width: '16px',
          height: '16px',
          cursor: 'pointer',
          background: 'transparent',
          border: 'none',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#8797AB',
          '&:hover': {
            color: 'text.main',
          },
        }}
      >
        <X size={16} aria-hidden="true" focusable="false" />
      </Box>

      <Flex
        flexShrink={0}
        sx={{
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            left: '2px',
            bottom: '8px',
            width: '56px',
            height: '56px',
            background: '#fff',
            borderRadius: '99px',
            zIndex: 0,
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <RocketLaunch width={72} height={72} />
        </Box>
      </Flex>

      <Flex
        sx={{
          flexDirection: 'column',
          gap: '8px',
          flexGrow: 1,
          minWidth: 0,
        }}
      >
        <Text
          as="p"
          sx={{
            fontWeight: '600',
            fontSize: '14px',
            lineHeight: '1.4',
            color: 'text.dark',
          }}
        >
          Boost job applications with the new Application Boost Agent{' '}
        </Text>
        <Text
          as="p"
          sx={{
            fontSize: '14px',
            fontWeight: '500',
            lineHeight: '1.4',
            color: 'text.main',
          }}
        >
          Get highly qualified candidates for any job, with no manual work. Try it on any job below, you get{' '}
          <Text as="span" sx={{ fontWeight: '600', color: 'text.dark' }}>
            one free Application Boost every month!
          </Text>
        </Text>
      </Flex>
    </Flex>
  </Box>
);

SourcingBanner.propTypes = {
  setIsVisible: PropTypes.func.isRequired,
};
